export default __webpack_public_path__ + "static/media/M2.68f6a5e4.png";